/**
 * Reopening the cookie choice - FRONTEND.md §9.738, owner O108, FB-1044.
 *
 * *"For cookies in customer website - make sure it will be at the bottom on footer, where you can change it
 * anytime (legal reasons) - so when you click on it, cookies will show again and you can change your
 * preferences."* GDPR art. 7(3) asks that withdrawing consent be as easy as giving it, and once the cookie card
 * had been answered nothing on the site could bring it back.
 *
 * **One way in, and it is an event.** The card belongs to `customer-consent`; the controls that open it are the
 * shell's footer and its phone sheet. §5 forbids the shell reaching into a module's internals and a module
 * importing another, so the two meet here: the shell calls `openCookieSettings()`, the card listens for
 * `COOKIE_SETTINGS_EVENT`, and neither needs anything from the other.
 *
 * The name keeps legacy's `fk:` prefix, which `fk:cookie-consent` already carries, so the two events read as a
 * pair to anybody listening on `window`.
 */
export const COOKIE_SETTINGS_EVENT = 'fk:cookie-settings'

/** Asks the cookie card to reopen on its settings panel, showing what the customer chose last time. */
export function openCookieSettings(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT))
}
